import { Injectable } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import {
	DATE_YMD,
	ProjectCarrierMapDTO,
	ProjectDTO,
	TOMORROW,
	IS_NOT_EMPTY,
	IS_NULL_OR_UNDEFINED,
} from 'cargo-chief-commons';
import { ConfirmationDialogComponent } from '../../common/confirmation-dialog/confirmation-dialog.component';
import { CapacitySearchFilterService } from '../capacitySearchFilter/capacity-search-filter.service';
import { LoadDetailsFormDialog } from '../../load-form/load-details-form/load-details-form.component';

@Injectable({
	providedIn: 'root',
})
export class ProjectDetailsService {
	constructor(
		private dialog: MatDialog,
		private capacitySearchFilterService: CapacitySearchFilterService
	) {}

	getSearchTruckForm(project: ProjectDTO) {
		const { originDeadhead, destinationDeadhead } = this.capacitySearchFilterService.getDeadhead();
		return {
			origin: {
				city: project.originCity,
				state: project.originState,
				zip: project.originZip,
				latitude: project.originLat,
				longitude: project.originLng,
			},
			destination: {
				city: project.destCity,
				state: project.destState,
				zip: project.destZip,
				latitude: project.destLat,
				longitude: project.destLng,
			},
			trailerType: project.equipmentType,
			pickupDateStart: DATE_YMD(TOMORROW()),
			pickupDateEnd: DATE_YMD(TOMORROW()),
			originDeadhead: originDeadhead,
			destinationDeadhead: destinationDeadhead,
			blanketWrap: false,
			driverAssistLoading: false,
			driverAssistUnloading: false,
			eTrackStabilization: false,
			frozen: false,
			handLoadingRequired: false,
			homeDelivery: false,
			liftgateRequired: false,
			morningPickup: false,
			strapsRequired: false,
			tarpsRequired: false,
			teamService: false,
			whiteGlove: false,
		};
	}

	isRequireTeamsUpdated({
		oldProjectDTO,
		newProjectDTO,
	}: {
		oldProjectDTO: ProjectDTO;
		newProjectDTO: ProjectDTO;
	}): { requireTeamsEnabled: boolean; requireTeamsDisabled: boolean } {
		const result = { requireTeamsEnabled: false, requireTeamsDisabled: false };
		if (oldProjectDTO.requireTeams != newProjectDTO.requireTeams) {
			if (newProjectDTO.requireTeams) {
				result.requireTeamsEnabled = true;
			} else {
				result.requireTeamsDisabled = true;
			}
		}
		return result;
	}

	showProcuredCarriersRemovalConfirmation() {
		return this.dialog
			.open(ConfirmationDialogComponent, {
				width: '500px',
				data: {
					title: 'Please confirm your action',
					body: `Remove all carriers without teams support?`,
					cancelButtonText: 'Cancel',
					ConfirmButtonTest: 'Confirm',
				},
			})
			.afterClosed()
			.toPromise();
	}

	getProjectCarrierMapIdsWithoutTeams(
		projectCarrierMapList: Array<ProjectCarrierMapDTO>
	): Array<string> {
		let projectCarrierMapIds = [];
		projectCarrierMapList.forEach((projectCarrierMap) => {
			if (!projectCarrierMap.carrier.hasTeams) {
				projectCarrierMapIds.push(projectCarrierMap.id);
			}
		});
		return projectCarrierMapIds;
	}

	openBADialog(accountCarrierMapCount, projectDTO) {
		let modalBody = '',
			modalTitle = '',
			isCityMissing = false,
			searchTruckForm = this.getSearchTruckForm(projectDTO);
		if (
			IS_NOT_EMPTY(searchTruckForm.origin.city) &&
			IS_NOT_EMPTY(searchTruckForm.destination.city)
		) {
			isCityMissing = false;
		} else {
			isCityMissing = true;
		}
		if (
			(IS_NULL_OR_UNDEFINED(accountCarrierMapCount) ? true : accountCarrierMapCount > 0) &&
			!isCityMissing
		) {
			const dialogRef = this.dialog.open(LoadDetailsFormDialog, {
				panelClass: 'cargo_chief_dialog_container',
				width: '950px',
				data: {
					searchTruckForm: searchTruckForm,
					matchedCarrierIds: [],
				},
				disableClose: true,
			});
			return;
		} else if (
			(IS_NULL_OR_UNDEFINED(accountCarrierMapCount) ? false : accountCarrierMapCount == 0) &&
			!isCityMissing
		) {
			modalTitle = `Get Options Setup`;
			modalBody = `Get Options only emails carriers in your network. Submit your carriers to customercare@cargochief.com to get started.`;
		} else if (isCityMissing) {
			modalTitle = `Get Options Setup`;
			modalBody = `Booking Assistant only works for city to city searches.`;
		}

		const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
			panelClass: 'cargo_chief_dialog_container',
			width: '550px',
			data: {
				title: modalTitle,
				body: modalBody,
				cancelButtonText: '',
				ConfirmButtonTest: 'Okay',
				showCloseButton: false,
				buttonActionLayout: 'end center',
			},
		});
	}
}
